import { QuickTable, QuickTableFilterTabs } from "../../components";
import { CreatePayment } from "./CreatePayment";
import { transactionDisplayFormatter } from "./transactionDisplayFormatter";
import { ITransactionViewProps } from "./Transactions";

export const View = (props: ITransactionViewProps) => {
  return (
    <>
      <QuickTable
        id="transactionsTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={false}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={transactionDisplayFormatter}
        onExport={props.onExport}
        openCreateNewModal={props.openCreateNewModal}
      />

      <CreatePayment
        isModalOpen={props.isCreateNewModalOpen}
        closeModal={props.closeModal}
      />
    </>
  );
};
